import { css } from 'linaria';

export const stageList = css`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: 0;
  margin: 0;
  column-gap: 32px;
  list-style: none;
  row-gap: 32px;

  @media (--only-tablet) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (--only-mobile) {
    grid-template-columns: 1fr;
    column-gap: 0;
    row-gap: 24px;
  }
`;

export const stageImage = css`
  display: block;
  width: 100%;
  height: 262px;
  margin-bottom: 24px;
  border-radius: var(--rounding-l);
  object-fit: cover;

  @media (--only-desktop) {
    height: 200px;
  }

  @media (--to-desktop) {
    height: 256px;
    margin-bottom: 16px;
  }
`;

export const stageName = css`
  && {
    display: block;
    margin-bottom: 8px;

    @media (--to-desktop) {
      width: 280px;
      font-size: 20px;
      line-height: 28px;
    }

    @media (--only-mobile) {
      width: auto;
    }
  }
`;

export const stageText = css`
  @media (--only-tablet) {
    width: 280px;
  }

  @media (--only-mobile) {
    && {
      font-size: 16px;
      line-height: 22px;
    }
  }
`;
